import { GeneralEnquiries } from "./generalenquiries";
import { GrantApplications } from "./grantapplications";
import { LastingPowersOfAttorneys } from "./lastingpowersofattorneys";
import { LssLastingPowerOfAttorneys } from "./LssLastingPowerOfAttorneys";
import { LsseStateAdmins } from "./lssestateadmins";
import { LssWills } from "./lsswills";
import {Wills} from "./Wills"
import { EstateAdminstration } from "./EstateAdminstration";
import {LssGrantApplications} from "./LssGrantApplication"
// import {Conveycing} from "./Conveycing"
import { useParams } from "react-router-dom";
import SimpleConveyancingForm from "./SimpleConveyancingForm";


// const CreateProductLeadView = {
//    "lasting-powers-of-attorney":<EstateAdminstration />
// }
export default function CreateProductLeadView() {
  const { slug } = useParams();
  return (
    <>
      {slug === "estate-administration" && <EstateAdminstration />}
      {slug === "general-enquiry" && <GeneralEnquiries />}
      {slug === "grant-application" && <GrantApplications />}
      {slug === "lasting-powers-of-attorney" && <LastingPowersOfAttorneys/>}
      {slug === "lss-lasting-powers-of-attorney" && <LssLastingPowerOfAttorneys />}
      {slug === "lss-estate-administration" && <LsseStateAdmins/>}
      {slug === "lss-grant-application" && <LssGrantApplications/>}
      {slug === "lss-will" && <LssWills />}
      {slug === "will" && <Wills />}
      {/* {slug === "conveyancing" && <Conveycing/>} */}
      
      {slug === "conveyancing" && <SimpleConveyancingForm/>}
    </>
  );
}
